import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastProvider } from "@swordsweeper/ssi-ui-component-library";
import SignUpPage from "@src/components/pages/clinic-portal/SignUpPage";
import EmailSentPage from "@src/components/pages/clinic-portal/EmailSentPage";

/**
 * Standalone entry point for the public sign-up flow.
 *
 * Sign-up is anonymous, so it deliberately does NOT load the authenticated
 * `app` bundle (whose global stores fetch user/cart/distributor data at import
 * and would 401 for logged-out visitors). It ships as its own lean bundle and
 * is served outside the `/app` URL space, which lets `/app` stay
 * authenticated-only.
 */
const SignUpApp = (
  <BrowserRouter>
    <ToastProvider>
      <Routes>
        <Route path="/sign-up" element={<SignUpPage />} />
        <Route path="/sign-up/email-sent" element={<EmailSentPage />} />
      </Routes>
    </ToastProvider>
  </BrowserRouter>
);

const container = document.getElementById("signup-root");
if (container) {
  createRoot(container).render(SignUpApp);
}
